"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_query_1 = require("@tanstack/react-query");
const store_1 = require("../../../store/store");
const Logout = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const queryClient = (0, react_query_1.useQueryClient)();
    (0, react_1.useEffect)(() => {
        axios
            .get('/api/auth/logout')
            .then((response) => response.data)
            .then((logoutResponse) => {
            queryClient.invalidateQueries();
            store_1.persistor.pause();
            store_1.persistor.flush().then(() => {
                setTimeout(() => {
                    store_1.persistor.purge().then(() => {
                        if (logoutResponse.externalLogin && logoutResponse.wasLoggedIn) {
                            navigate('/auth/logout-external', {
                                state: { redirectUrl: logoutResponse.redirectUrl },
                            });
                        }
                        else {
                            navigate('/auth/login');
                        }
                    });
                }, 200);
            });
        });
    }, [navigate, queryClient]);
    return null;
};
exports.default = Logout;
